import { DomainError } from '../domain/DomainError';

const MENSAJE_DEFAULT = 'Ocurrió un error al comunicarse con el servidor';
const MENSAJE_RED = 'No hay conexión con el servidor';
const MENSAJE_SERVIDOR = 'Ocurrió un error en el servidor; intenta de nuevo';
const MENSAJES_HTTP = {
  400: 'Solicitud inválida',
  401: 'Tu sesión expiró; inicia sesión de nuevo',
  403: 'No tienes permisos para esta acción',
  404: 'Registro no encontrado',
  405: 'Acción no disponible por ahora',
  413: 'El archivo es demasiado grande',
};

const mensajePorStatus = status => {
  if (status === null || status === undefined) return MENSAJE_RED;
  if (status >= 500) return MENSAJE_SERVIDOR;
  return MENSAJES_HTTP[status] || MENSAJE_DEFAULT;
};

// Respuesta propia de la API (tiene la llave `success`): su mensaje es apto para el usuario.
const isControlled = body => !!body && typeof body === 'object' && 'success' in body;

// Laravel: { campo: ['msg1', 'msg2'] } -> lista plana de mensajes
const flattenErrors = errors => {
  if (!errors || typeof errors !== 'object') return [];
  return Object.keys(errors).reduce((acc, key) => acc.concat(errors[key]), []);
};

const toFieldErrors = errors => (errors && typeof errors === 'object' && !Array.isArray(errors) ? errors : null);

const buildError = (body, status) => {
  const controlled = isControlled(body);
  const fromErrors = flattenErrors(body && body.errors);
  // Los `errors` de validación de Laravel (422) son para el usuario aunque no venga `success`.
  if (fromErrors.length) return new DomainError(fromErrors, toFieldErrors(body.errors), status, true);
  if (controlled && body.message) return new DomainError(body.message, null, status, true);
  return new DomainError(mensajePorStatus(status), null, status, false);
};

/** Construye el DomainError desde un cuerpo ya parseado y el status (mismas reglas que `unwrap`). */
export const errorDesdeRespuesta = (body, status) => buildError(body, status);

const isFailure = data => data && (data.success === false || data.success === 0);

/**
 * Espera una promesa de axios y devuelve `response.data`.
 * El backend responde HTTP 200 con { success: false } en validaciones: aquí se convierte en DomainError.
 */
export const unwrap = async axiosPromise => {
  let response;
  try {
    response = await axiosPromise;
  } catch (e) {
    if (e instanceof DomainError) throw e;
    const status = e && e.response ? e.response.status : null;
    const body = e && e.response ? e.response.data : null;
    // Solo se confía en mensajes de respuestas controladas (con `success`); si no, mensaje en español por status
    throw buildError(body, status);
  }
  const data = response.data;
  if (isFailure(data)) throw buildError(data, 200);
  return data;
};

/** POST/PUT devuelven `data: [obj]`; toma el primer elemento. */
export const firstItem = body => {
  const list = body && body.data;
  return Array.isArray(list) ? list[0] : list;
};
